import { module } from 'modujs';
import { gsap } from 'gsap';
import { random } from '../utils/maths';

export default class extends module {
    constructor(m) {
        super(m);

        this.$images = this.$('images');
        this.$link = this.$('link');

        this.events = {
            mouseenter: {
                link: 'enter'
            },
            mouseleave: {
                link: 'leave'
            }
        }
    }

    init() {

    }

    enter(e) {
        if(window.isMobile) return;

        let $el = e.currentTarget;
        let target = $el.getAttribute('data-target');

        this.$images.forEach($imageGroup => {
            
            if($imageGroup.getAttribute('data-slug') == target) {
                let $images = $imageGroup.querySelectorAll('.js-image');

                if(!$imageGroup.classList.contains('is-active')) {
                    $images.forEach(($image, index) => {
                        if(index == 0) {
                            $image.style.left = `${random(0, (window.innerWidth/2) - $image.getBoundingClientRect().width * 1.5)}px`;
                            $image.style.top = `${random(0, (window.innerHeight/2) - $image.getBoundingClientRect().height/2)}px`;
                        } else if (index == 1) {
                            $image.style.right = `${random(0, (window.innerWidth/2) - $image.getBoundingClientRect().width * 1.5)}px`;
                            $image.style.top = `${random(0, (window.innerHeight/2) - $image.getBoundingClientRect().height/2)}px`;
                        } else if(index == 2) {
                            if(random(0,1) < 0.5) {
                                $image.style.left = `${random(0, (window.innerWidth/2) - $image.getBoundingClientRect().width * 1.5)}px`;
                            } else {
                                $image.style.left = `${random((window.innerWidth/2) + $image.getBoundingClientRect().width * 1.5, window.innerWidth - $image.getBoundingClientRect().width * 1.5)}px`;
                            }
                            $image.style.top = `${random((window.innerHeight/2) - $image.getBoundingClientRect().height/2, window.innerHeight - $image.getBoundingClientRect().height/2)}px`;
                        }
                        
                    });
                }

                if($imageGroup.callback !== undefined) {
                    $imageGroup.callback.kill();
                }
                $imageGroup.classList.add('is-active');
                $imageGroup.classList.remove('is-leaving');
            }
        });
    }

    leave(e) {
        if(window.isMobile) return;
        
        let $el = e.currentTarget;
        let target = $el.getAttribute('data-target');

        this.$images.forEach($imageGroup => {
            if($imageGroup.getAttribute('data-slug') == target) {
                $imageGroup.classList.add('is-leaving');

                $imageGroup.callback = gsap.delayedCall(0.98, () => {
                    $imageGroup.classList.remove('is-leaving');
                    $imageGroup.classList.remove('is-active');
                });
            }
        });
    }
}
